import {useQuery} from '@tanstack/react-query'
import {ApiUrls} from "../config/urls";
import axios from "axios";

const fetchGuidebook = (queryKey) => {
    let path = typeof queryKey === 'string' ? queryKey : queryKey[0];

    return axios.get(`${path}`).then((res) => res.data?.data ? res.data.data : res.data)
}

export function useGuidebook(slug, language) {

    const url =  ApiUrls.GUIDEBOOK.replace('{slug}', slug).replace('{lng}', language);
    const options = {
        queryKey:  [url, {slug: slug, language: language}],
        queryFn: ({queryKey}) => fetchGuidebook(queryKey)
    }

    return useQuery(options);
}

export function useGuidebookValidation(slug, language) {
    const url =  ApiUrls.GUIDEBOOK_VALIDATION.replace('{slug}', slug).replace('{lng}', language);

    const options = {
        queryKey:  [url, {slug: slug, language: language}],
        queryFn: ({queryKey}) => fetchGuidebook(queryKey)
    }

    return useQuery(options);
}